import { cva } from '@/utils/classnames/cva';
import { classnames } from '@/utils/classnames/classnames';
import { Variant } from '../../types';

const useClassNames = (variant: Variant) => {
  const resolveVariant = cva({
    default: 'pb-4 md:pb-7 md:pt-8',
    simple: 'py-8 lg:py-10',
  });

  // EWM-622 — no top margin on the footer. The old `mt-12` opened a 48px gap
  // above the footer that the page shell (`bg-gray-100`) painted through,
  // showing a stray grey band on pages whose content ends flush (e.g. a PDP
  // with no related-products carousel). The footer now sits directly below the
  // page content; any page that genuinely needs breathing room re-adds it in
  // Studio with a coloured spacer component (per Luke, 2026-07-02).
  const className = classnames('bg-primary', resolveVariant(variant) as string);

  return { className };
};

export default useClassNames;
